<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="calculator-popup">
    <div class="main-title">
        <h1>{{ contents.calculator.header }}</h1>
        <h2>{{ contents.calculator.subHeader }}</h2>
    </div>
    <div class="standing-order-wrapper">
        <app-calculator-section [sectionData]="sectionsData[0]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[1]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[2]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[3]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[4]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[5]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[6]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[7]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[8]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[9]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[10]"></app-calculator-section>
        <app-calculator-section [sectionData]="sectionsData[11]"></app-calculator-section>
    </div>

    <div class="button-wrapper">
        <div class="month-sum">
            סך הכל : <span>₪</span>{{ totalSum() | number }}
            בחודש
        </div>
        <a (click)="transferDirectDebits()" title="" class="brand-button green-button"><span>חשבו לי את ההטבות </span></a>
    </div>
    <div *ngIf="isShowErrorMsg()" class="error-msg-wrapper show-err-msg">
        <span class="error-msg">יש למלא לפחות קובייה אחת בסכום הוראות הקבע</span>
    </div>
</div>
